import React from 'react';


function Header() {
  return (
    <header style={{ backgroundColor: ' #FFA07A', color: '#fff', padding: '10px' }}>
      <p style={{ margin: 0 }}>Informaciòn y noticias</p>
     
    </header>
    
    
    
    
  );
}

export default Header;
